import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell, { authField, authBtn } from "./AuthShell";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "", phone: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(form);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle="Join the portal to request transport and track deliveries."
      footer={
        <>
          Already registered?{" "}
          <Link to="/login" className="text-gold link-underline" data-testid="to-login">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="Full name" value={form.name} onChange={set("name")} className={authField} data-testid="reg-name" />
        <input type="email" required placeholder="Email" value={form.email} onChange={set("email")} className={authField} data-testid="reg-email" />
        <div className="grid grid-cols-2 gap-4">
          <input placeholder="Company / NGO" value={form.company} onChange={set("company")} className={authField} data-testid="reg-company" />
          <input placeholder="Phone" value={form.phone} onChange={set("phone")} className={authField} data-testid="reg-phone" />
        </div>
        <input type="password" required placeholder="Password" value={form.password} onChange={set("password")} className={authField} data-testid="reg-password" />
        {error && <p className="text-sm text-red-400" data-testid="reg-error">{error}</p>}
        <button type="submit" disabled={loading} className={authBtn} data-testid="reg-submit">
          {loading && <Loader2 size={18} className="animate-spin" />}
          {loading ? "CREATING..." : "CREATE ACCOUNT"}
        </button>
      </form>
    </AuthShell>
  );
}
